module.exports = __webpack_public_path__ + "static/media/lorry_24ft.1130943f.svg";